import * as React from 'react'	
import { RouteComponentProps } from 'react-router'	
import { IRiderObject } from '../../../../types'	
import UIMessages from '../../../../utils/ui-messages'	
import Modal from '../../../ui/Modal'	

interface IAddBonusModalProps {	
  rider: IRiderObject	
  onClose: () => void	
  addBonus: (riderId: string, amount: number, message: string) => Promise<any>	
}	

interface IAddBonusModalState {	
  isSubmitting: boolean	
  error: string	
  amount: number	
  message: string	
}	

class AddBonusModal extends React.Component<IAddBonusModalProps, IAddBonusModalState> {	
  public state = {	
    isSubmitting: false,	
    error: '',	
    amount: 0,	
    message: ''	
  }	

  public render() {	
    const saveText = this.state.isSubmitting ? 'Saving...' : UIMessages.common.addBonus	

    return (	
      <Modal>	
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>	
          <div className='bg-white col-3 p2'>	
            <span className='ModalAddTitle weight-300 font-grey2 ml2 mr2 mb1 uppercase'>	
              {UIMessages.common.addBonusToWallet}	
            </span>	
            <div	
              style={{	
                pointerEvents: this.state.isSubmitting ? 'none' : 'auto',	
                opacity: this.state.isSubmitting ? 0.4 : 1.0	
              }}	
              className='ml2 mr2 mt1'	
            >	
              <div>	
                <label htmlFor='bonusBalance'>Bonus Amount</label>	
                <input	
                  id='bonusBalance'	
                  className='block col-3 p1 fit'	
                  type='number'	
                  min='1'	
                  max='500'	
                  placeholder='0.00'	
                  onChange={this.onAmountChange}	
                  value={this.state.amount}	
                />	
              </div>	
              <div className='mt1'>	
                <label htmlFor='bonusBalance'>Reason</label>	
                <textarea	
                  id='bonusReason'	
                  className='col-12 p1 fit'	
                  placeholder='Add Reason'	
                  onChange={this.onMessageChange}	
                  value={this.state.message}	
                />	
              </div>	
            </div>	
            <div className='flex items-center justify-end mt3'>	
              <button	
                type='button'	
                onClick={this.handleCancelClick}	
                disabled={this.state.isSubmitting}	
                className='CancelButton btn bg-white rounded font-light-grey mr2'	
              >	
                {UIMessages.common.cancel}	
              </button>	
              <button	
                type='button'	
                onClick={this.onAddBonus}	
                disabled={this.state.isSubmitting}	
                className='SubmitButton btn bg-green rounded font-white weight-300'	
              >	
                {saveText}	
              </button>	
            </div>	
          </div>	
        </div>	
      </Modal>	
    )	
  }	

  private onMessageChange = (e: any) => this.setState({ message: e.target.value })	

  private onAmountChange = (e: any) => this.setState({ amount: e.target.value })	

  private handleCancelClick = () => {	
    this.props.onClose()	
  }	

  private onAddBonus = async () => {	
    if (!this.state.amount) {	
      return	
    }	

    this.setState({ isSubmitting: true })	
    const result = await this.props.addBonus(this.props.rider.id, this.state.amount || 0, this.state.message)	
    if (result.status && result.status >= 400) {	
      this.setState({	
        isSubmitting: false,	
        error: result.data	
      })	
    } else {	
      this.handleCancelClick()	
    }	
  }	
}	

export default AddBonusModal


// WEBPACK FOOTER //
// ./src/components/riders/riderdetails/wallet/AddBonusModal.tsx